import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useUsageRecords} from '../hooks/useUsageRecords.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useUsageRecords();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};

